export default {
	evaluations: [
		{
			id: 1,
			activityId: 5,
			type: 'trivia',
			maxScore: 100,
			title: 'Trivia de aprendizaje',
			description: `
			<p>
				<b>¡Es un momento de reto!​</b>
				<br/>
				Iniciaremos un juego que pondrá a prueba todo lo que has aprendido, se trata de una trivia, la cual consta de 10 preguntas más una pregunta de rescate, con un valor de 10 puntos cada una. 
				<br/>
				Para aprobar deberás acumular 80 puntos.​
				<br/>
				En cada pregunta podrás utilizar dos comodines y sólo podrás ocuparlos una vez.
				<br/>
				<b>¿Listo para el reto?​​</b>
			</p>`,
			questions: [
				{
					id: 1,
					title: '¿En BBVA quiénes son considerados Sujetos de Crédito?',
					options: [
						{
							id: 1,
							text: 'Personas físicas con o sin actividad empresarial y personas morales nacional o extranjero, gobiernos federales, estatales y municipales, organismos de la administración público federal, y fideicomisos públicos que estén constituidas bajo las leyes mexicanas.',
						},
						{
							id: 2,
							text: 'Instituciones privadas con diversos giros comerciales nacionales e internacionales, instituciones y organismos gubernamentales de tipo federal, estatal o municipal. Se rigen por la normatividad mexicana.',
						},
						{
							id: 3,
							text: 'Empresas nacionales, gobiernos federales, fideicomisos privados y públicos, organismos estatales y municipales que estén constituidas bajo las leyes mexicanas.',
						},
					],
					answers: [1],
				},
				{
					id: 2,
					title: '¿Identifica algunos de los sujetos no recomendables para BBVA?',
					options: [
						{
							id: 1,
							text: 'Conductores, artistas, iglesias, asociaciones religiosas y gobiernos.',
						},
						{
							id: 2,
							text: 'Diplomáticos, artistas, iglesias y asociaciones religiosas.',
						},
						{
							id: 3,
							text: 'Artistas, iglesias, asociaciones religiosas y empresas importadoras.',
						},
					],
					answers: [2],
				},
				{
					id: 3,
					title: '¿A qué se refiere la fracción III del Artículo 112?',
					options: [
						{
							id: 1,
							text: 'Serán sancionados los consejeros, funcionarios o empleados de la Institución de Crédito qué otorguen créditos a personas físicas o morales cuyo estado de insolvencia les sea conocido, que carecen de capacidad económica para pagar o responder por el importe de las sumas acreditadas, produciendo quebranto o perjuicio patrimonial a la Institución.',
						},
						{
							id: 2,
							text: 'Todos los créditos donde el representante legal sea consejero del banco se deberán autorizar por el consejo de Administración de BBVA de lo contrario el crédito será retirado y el representante sancionado por incumplir los protocolos de originación de crédito.',
						},
						{
							id: 3,
							text: 'Cualquier persona física o moral, que represente un riesgo reputacional a la institución, como lo pueden ser artistas, políticos, personajes públicos o asociaciones civiles sin fines de lucro, no se consideran Sujetos de Crédito para la institución.',
						},
					],
					answers: [1],
				},
				{
					id: 4,
					title: '¿Qué Artículo de la Ley de instituciones de crédito contempla los Créditos Relacionados?',
					options: [
						{
							id: 1,
							text: 'Artículo 112.',
						},
						{
							id: 2,
							text: 'Artículo 106.',
						},
						{
							id: 3,
							text: 'Artículo 73.',
						},
					],
					answers: [3],
				},
				{
					id: 5,
					title: '¿En qué tipo de administración algunos puestos claves son ocupados por profesionales con grado universitario?',
					options: [
						{
							id: 1,
							text: 'Familiar.',
						},
						{
							id: 2,
							text: 'Semiprofesional.',
						},
						{
							id: 3,
							text: 'Profesional.',
						},
						{
							id: 4,
							text: 'Institucional.',
						},
					],
					answers: [2],
				},
				{
					id: 6,
					title: 'Conocer el sector económico del cliente…',
					options: [
						{
							id: 1,
							text: 'Nos permite conocer el negocio del cliente, si presenta concentración de clientes o proveedores, ya que esto puede representar un riego para, la recuperación del crédito.',
						},
						{
							id: 2,
							text: 'Nos permite conocer los resultados de la empresa o grupo, con respecto a la situación del sector al que pertenece, así como las tendencias y perspectivas esperadas y futuras.',
						},
						{
							id: 3,
							text: 'Nos ayuda a conocer la información comercial de la empresa o grupo para poder tomar una decisión sobre la recuperación del crédito según la situación del sector al que pertenece y el nivel de riesgo.',
						},
					],
					answers: [2],
				},
				{
					id: 7,
					title: '¿En México como están agrupados los sectores económicos?',
					options: [
						{
							id: 1,
							text: 'Primario, secundario y terciario.',
						},
						{
							id: 2,
							text: 'Agricultura, industria y comercio.',
						},
						{
							id: 3,
							text: 'Servicios, petroquímica y comercio.',
						},
					],
					answers: [1],
				},
				{
					id: 8,
					title: '¿Por qué es importante conocer el diagrama de Porter en el entendimiento de la posición en el mercado de las empresas?',
					options: [
						{
							id: 1,
							text: 'Ayuda a entender el negocio del cliente, y las características del sector dónde se desenvuelve, ya que es muy importante identificar si los indicadores de la empresa son similares a los del sector.',
						},
						{
							id: 2,
							text: 'Porque permite identificar su competencia en comparación a la habilidad que tiene en la satisfacción de sus clientes y la rentabilidad que esto significa para sacar a flote el negocio.',
						},
						{
							id: 3,
							text: 'Porque permite esclarecer tanto la competencia y rivalidad que enfrenta en la industria, como su habilidad para satisfacer a sus clientes, sus oportunidades de inversión y rentabilidad.',
						},
					],
					answers: [3],
				},
				{
					id: 9,
					title: 'En el análisis FODA hablar de las Debilidades de las empresas, nos pide identificar…',
					options: [
						{
							id: 1,
							text: 'Los aspectos negativos de la organización, así como su procedencia para poder calcular los posibles riesgos y construir soluciones que las transformen en oportunidades o fortalezas.',
						},
						{
							id: 2,
							text: 'Identificar su posición financiera dentro del Sector, así como su organización y los aspectos de control que ayudan en la construcción de brechas para lograr una buena marcha de la organización.',
						},
						{
							id: 3,
							text: 'Los elementos que tiene la empresa, aspectos del servicio que se brinda, aspectos financieros, aspectos de mercado, aspectos organizativos y aspectos de control que constituyen barreras para lograr la buena marcha de la organización.',
						},
					],
					answers: [3],
				},
				{
					id: 10,
					title: '¿Cuáles son las etapas del ciclo de vida de las industrias?',
					options: [
						{
							id: 1,
							text: 'Crecimiento, Madurez y Fragmentación.',
						},
						{
							id: 2,
							text: 'Introducción, Crecimiento, Madurez, Decadencia, Renovación o Fragmentación.',
						},
						{
							id: 3,
							text: 'Inicio, Crecimiento y Madurez.',
						},
					],
					answers: [2],
				},
				{
					id: 11,
					title: '¿Cuál es una de la característica de la etapa de Introducción? ',
					options: [
						{
							id: 1,
							text: 'Son empresas que llevan 2 años de constitución.',
						},
						{
							id: 2,
							text: 'Son empresas bien constituidas.',
						},
						{
							id: 3,
							text: 'Son empresas que entran al mercado con una innovación tecnológica.',
						},
					],
					answers: [3],
				},
				{
					id: 12,
					title: '¿Por qué es importante la etapa de renovación en el ciclo de vida de la industria?',
					options: [
						{
							id: 1,
							text: 'Porque es el momento de innovar, renovarse y hacer adaptaciones al modelo de negocio, invirtiendo e igualando lo que el líder del mercado tiene para poder sobrevivir y volver a crecer.',
						},
						{
							id: 2,
							text: 'Para vender más estableciendo una meta específica que permita realizar una nueva inversión en búsqueda de un nuevo crecimiento.',
						},
						{
							id: 3,
							text: 'Es el momento de trasladarse a otros mercados y desarrollar nuevas estrategias, con el objetivo de mantenerse vigentes dentro del sector.',
						},
					],
					answers: [1],
				},
			]
		},
		{
			id: 2,
			activityId: 6,
			type: 'trivia',
			maxScore: 100,
			title: 'Trivia de aprendizaje',
			description: `
			<p>
				<b>¡Bienvenido de nuevo!</b>
				<br/>
				Vamos a continuar descubriendo que tanto has aprendido, de nuevo responderás 10 preguntas más una pregunta de rescate, recuerda que cada pregunta tiene un valor de 10 puntos.
				<br/>
				<b>¿Listo para el segundo reto de aprendizaje?​​</b>
			</p>`,
			questions: [
				{
					id: 1,
					title: '¿En qué etapa del proceso de crédito puedes detectar desviaciones en la calidad crediticia?',
					options: [
						{
							id: 1,
							text: 'Recuperación.',
						},
						{
							id: 2,
							text: 'Formalización.',
						},
						{
							id: 3,
							text: 'Seguimiento.',
						},
					],
					answers: [3],
				},
				{
					id: 2,
					title: '¿En qué estado financiero podemos analizar los ingresos, costos y gastos de una empresa en un periodo determinado?',
					options: [
						{
							id: 1,
							text: 'Situación Financiera o Balance General',
						},
						{
							id: 2,
							text: 'Estado de Resultados.',
						},
						{
							id: 3,
							text: 'Estado de Flujo de Efectivo.',
						},
						
					],
					answers: [2],
				},
				{
					id: 3,
					title: '¿Qué métodos ocupamos para el análisis de los estados Financieros?',
					options: [
						{
							id: 1,
							text: 'Análisis vertical y Razones Financieras.',
						},
						{
							id: 2,
							text: 'Análisis vertical, Análisis horizontal.',
						},
						{
							id: 3,
							text: 'Análisis vertical, análisis horizontal y el método directo e indirecto del efectivo.',
						},
					],
					answers: [3],
				},
				{
					id: 4,
					title: '¿Qué información obtienes al realizar un análisis horizontal?',
					options: [
						{
							id: 1,
							text: 'Las variaciones que han sufrido las partidas de resultados o de balance en dos o más períodos consecutivos.',
						},
						{
							id: 2,
							text: 'Un análisis porcentual de cuentas específicas con base cien para realizar diagnósticos financieros con la finalidad de identificar las partidas más relevantes, ya que estas nos indican una concentración considerable de recursos líquidos, en un mismo período.',
						},
						{
							id: 3,
							text: 'Los movimientos del efectivo según las categorías principales de cobros y pagos en términos brutos, distinguiendo entre: actividades de operación, de inversión y financiamiento.',
						},
					],
					answers: [1],
				},
				{
					id: 5,
					title: '¿Qué información obtienes al realizar un análisis Vertical?',
					options: [
						{
							id: 1,
							text: 'Las variaciones que ha sufrido cada una de las partidas de la cuenta de resultados o la del balance en dos o más períodos consecutivos. Por tanto, se centra en averiguar qué ha sucedido con una partida contable en un período determinado.',
						},
						{
							id: 2,
							text: 'Un análisis porcentual con base cien para realizar diagnósticos financieros, y se usa especialmente para identificar las partidas más relevantes o las de mayor peso en cifras de un mismo período.',
						},
						{
							id: 3,
							text: 'Los movimientos del efectivo según las categorías principales de cobros y pagos en términos brutos, distinguiendo entre: actividades de operación, de inversión y financiamiento.',
						},
					],
					answers: [2],
				},
				{
					id: 6,
					title: '¿En qué caso se considera que una empresa está en estado de disolución?',
					options: [
						{
							id: 1,
							text: 'Cuando tiene pérdidas acumuladas equivalentes a 2 terceras partes de su capital social.',
						},
						{
							id: 2,
							text: 'Cuando tenga pérdidas acumuladas equivalentes a 1 cuarta parte de su capital social.',
						},
						{
							id: 3,
							text: 'Cuando tenga pérdidas acumuladas.',
						},
					],
					answers: [1],
				},
				{
					id: 7,
					title: '¿Qué es una razón financiera?',
					options: [
						{
							id: 1,
							text: 'Es un indicador utilizado en el mundo de las finanzas para medir o cuantificar la realidad económica y financiera de una empresa o unidad evaluada, y su capacidad para asumir las diferentes obligaciones.',
						},
						{
							id: 2,
							text: 'Son evaluaciones utilizadas en el mundo de las finanzas para saber la liquidez, y los recursos disponibles con los que cuenta la empresa, ya sea para invertir o para respaldar operaciones de crédito.',
						},
						{
							id: 3,
							text: 'Son Formulas para saber si la empresa está ganando dinero.',
						},
					],
					answers: [1],
				},
				{
					id: 8,
					title: '¿Para qué nos sirve una razón financiera?',
					options: [
						{
							id: 1,
							text: 'Para entender verticalmente el Balance General, e identificar las partidas donde existe una concentración considerable de recursos, y poder dar una explicación.',
						},
						{
							id: 2,
							text: 'Para saber cómo se distribuyó el flujo financiero de la empresa e identificar las partidas donde existe una concentración considerable de recursos.',
						},
						{
							id: 3,
							text: 'Nos sirve para simplificar las cifras de los Estados Financieros y sus relaciones, y hacer factible las comparaciones para facilitar su interpretación.',
						},
					],
					answers: [3],
				},
				{
					id: 9,
					title: '¿Cuál es el objetivo de una calificación de crédito (Rating)?',
					options: [
						{
							id: 1,
							text: 'Calificar la capacidad de una entidad para pagar su deuda y a partir de ahí, estimar la probabilidad de incumplimiento.',
						},
						{
							id: 2,
							text: 'Categorizar en un ranking la capacidad de una entidad para pagar su deuda y a partir de ahí, estimar la probabilidad de incumplimiento.',
						},
						{
							id: 3,
							text: 'Es una calificación que nos ayuda a entender la realidad financiera de una empresa para estimar la probabilidad de incumplimiento.',
						},
					],
					answers: [2],
				},
				{
					id: 10,
					title: '¿Qué te permite calcular una proyección financiera?',
					options: [
						{
							id: 1,
							text: 'Las premisas de proyección de la empresa, tomando en cuenta elementos, como la inflación, y el estado actual de la economía.',
						},
						{
							id: 2,
							text: 'El ROE de la empresa en el futuro.',
						},
						{
							id: 3,
							text: 'Desde el punto de vista financiero y contable, cuál será el desenvolvimiento de tu empresa o negocio en un futuro determinado.',
						},
					],
					answers: [3],
				},
				{
					id: 11,
					title: '¿Qué es la Fuente Primaria de Pago (FPP)?',
					options: [
						{
							id: 1,
							text: 'Es la Fuente Esperada de Pago, que se debe generar preferentemente con base en las actividades propias del negocio, es decir con su Flujo Neto.',
						},
						{
							id: 2,
							text: 'Es el dinero líquido, que se obtiene después de cobrar a los clientes, las cuentas correspondientes al periodo contable, es decir las que corresponden al corto plazo.',
						},
						{
							id: 3,
							text: 'Son las ventas liquidadas de forma inmediata que permiten generar ingresos según su giro comercial.',
						},
					],
					answers: [1],
				}
			]
		},
		{
			id: 3,
			activityId: 7,
			type: 'trivia',
			maxScore: 100,
			title: 'Trivia de aprendizaje',
			description: `
			<p>
				<b>¡Es momento de otro reto!</b>
				<br/>
				Tienes otra oportunidad de ganar puntos, recuerda que cada pregunta tiene un valor de 10 puntos, ahora tendrás 2 preguntas de rescate para poder aprovechar el puntaje al máximo. 
				<br/>
				<b>¿Listo para ponerte a prueba?</b>
			</p>`,
			questions: [
				{
					id: 1,
					title: '¿Qué es un Pool Bancario o Cuadro de pasivos Bancarios?',
					options: [
						{
							id: 1,
							text: 'Es un informe de deuda detallado en el que se muestra la situación real de la empresa utilizado para recalcular los riesgos que asumiremos como institución.',
						},
						{
							id: 2,
							text: 'Es un detalle de cada una de las líneas de crédito vigentes que tiene la empresa (dispuesta o no dispuestas), lo anterior buscando tener plenamente identificado el Riesgo que asumiremos como Institución.',
						},
						{
							id: 3,
							text: 'Es un documento que incluye los vencimientos de las deudas de la empresa, así como el historial de pagos, en este documento se observa, el comportamiento crediticio de la empresa.',
						},
					],
					answers: [2],
				},
				{
					id: 2,
					title: '¿Cuál es la diferencia entre la Deuda Financiera reportada en los Estados Financieros EEFF, contra el Cuadro de Pasivos Bancarios?',
					options: [
						{
							id: 1,
							text: 'Que el Cuadro de Pasivos Bancarios proporcionar el total de sus líneas vigentes dispuestas o no dispuestas.',
						},
						{
							id: 2,
							text: 'Que el Cuadro de Pasivos Bancarios proporciona una parte de sus líneas vigentes dispuestas o no dispuestas.',
						},
						{
							id: 3,
							text: 'Que una muestra el total y la otra solo muestra lo vigente de las líneas vigentes dispuestas y no dispuestas con las que cuenta la empresa.',
						},
					],
					answers: [1],
				},
				{
					id: 3,
					title: '¿Qué es una ficha de rentabilidad?',
					options: [
						{
							id: 1,
							text: 'Es un informe que muestra las líneas de crédito que la empresa tiene contratados BBVA.',
						},
						{
							id: 2,
							text: 'Es un documento con los datos de los productos financieros y de servicios que tienen contratados nuestros clientes con BBVA.',
						},
						{
							id: 3,
							text: 'Es un catálogo de productos que pueden ser ofrecidos como complemento de los que ya tiene el cliente.',
						},
					],
					answers: [2],
				},
				{
					id: 4,
					title: '¿Qué información encuentras en la ficha de rentabilidad?',
					options: [
						{
							id: 1,
							text: 'La utilidad que genera el cliente con ayuda de los productos de captación de la Banca de Empresas haciendo que su rentabilidad aumente considerablemente.',
						},
						{
							id: 2,
							text: 'El ROA y ROE que genera el cliente, así como otros indicadores que nos muestran la rentabilidad, que la empresa es capaz de lograr, ya que esta información es fundamental para la autorización del crédito.',
						},
						{
							id: 3,
							text: 'Productos de Captación, Productos de Colocación, Productos No Financieros, Rentabilidad mensual y anual en Banca de Empresas y Rentabilidad mensual y anual Integral (Banca de Empresas y Otras Bancas)',
						},
					],
					answers: [3],
				},
				{
					id: 5,
					title: '¿Cuál es la función de La Mesa de Precios?',
					options: [
						{
							id: 1,
							text: 'Es un comité que fija las tasas de interés que nos muestre como la mejor opción en costos de fondeo de créditos.',
						},
						{
							id: 2,
							text: 'Fijar y analizar las tasas en función del mercado y los estándares del margen y las comisiones establecidas por la Bolsa de Valores.',
						},
						{
							id: 3,
							text: 'Es la encargada de negociar los mejores costos de fondeo para tus operaciones de crédito y busca siempre la maximización del margen y cobro de comisiones.',
						},
					],
					answers: [3],
				},
				{
					id: 6,
					title: '¿Qué factores determinan el margen objetivo en una operación de crédito?',
					options: [
						{
							id: 1,
							text: 'Rating, Segmento del cliente, Moneda, Plazo, Tipo de crédito, Presencia de garantías y derivados.',
						},
						{
							id: 2,
							text: 'Comportamiento de pago, el grado de apalancamiento, la liquidez y la capacidad de endeudamiento.',
						},
						{
							id: 3,
							text: 'Factores cualitativos, cuantitativos y específicos tomando como base la documentación solicitada para el tipo de crédito requerido.',
						},
					],
					answers: [1],
				},
				{
					id: 7,
					title: '¿Qué es una SIC?',
					options: [
						{
							id: 1,
							text: 'Sociedad de Información Crediticia.',
						},
						{
							id: 2,
							text: 'Sociedad Internacional de Crédito.',
						},
						{
							id: 3,
							text: 'Seguridad Inteligente Comercial.',
						},
					],
					answers: [1],
				},
				{
					id: 8,
					title: '¿Qué finalidad tiene una SIC?',
					options: [
						{
							id: 1,
							text: 'Generar una base de datos, para fijar tasas y precios y que las operaciones de crédito sean lo más transparentes posibles.',
						},
						{
							id: 2,
							text: 'Actualizar la base de deudores de una economía y compartirla con los bancos pertenecientes al organismo financiero en el que nos encontramos.',
						},
						{
							id: 3,
							text: 'Proporcionar información sobre operaciones activas y otras de naturaleza análoga, realizadas por entidades financieras.',
						},
					],
					answers: [3],
				},
				{
					id: 9,
					title: '¿Cuándo debemos realizar la consulta al buró de crédito?',
					options: [
						{
							id: 1,
							text: 'Cuando se presente un estudio de crédito, o una renovación de crédito y sea necesario un estudio de crédito.',
						},
						{
							id: 2,
							text: 'Cuando se inicie una relación con un cliente, se presente un estudio de crédito, de acuerdo con las políticas de seguimiento.',
						},
						{
							id: 3,
							text: 'Cuando existe una renovación de crédito y las políticas de seguimiento lo indiquen explícitamente.',
						},
					],
					answers: [2],
				},
				{
					id: 10,
					title: '¿Qué peso tiene el buró de crédito del cliente sobre la calificación Rating?',
					options: [
						{
							id: 1,
							text: 'Es uno de los factores que tiene menor peso en el puntaje de la calificación Rating.',
						},
						{
							id: 2,
							text: 'Es uno de los factores que no tiene peso en el puntaje de la calificación Rating.',
						},
						{
							id: 3,
							text: 'Es uno de los factores que tiene mayor peso en el puntaje de la calificación Rating.',
						},
					],
					answers: [3],
				},
				{
					id: 11,
					title: '¿Qué te indica la clave de prevención 92 en el Buró de crédito? ',
					options: [
						{
							id: 1,
							text: 'Cliente que proporcionó pérdida total al otorgante.',
						},
						{
							id: 2,
							text: 'Cliente en trámite Judicial por pérdida total al otorgante.',
						},
						{
							id: 3,
							text: 'Cliente declarado en quiebra, suspensión de pagos o en concurso mercantil.',
						},
					],
					answers: [1],
				},
				{
					id: 12,
					title: '¿Qué te indica la clave de prevención 80 en el Buró de crédito?',
					options: [
						{
							id: 1,
							text: 'Que el cliente proporcionó pérdida total al otorgante.',
						},
						{
							id: 2,
							text: 'Que el cliente se encuentre en trámite Judicial por pérdida total al otorgante.',
						},
						{
							id: 3,
							text: 'Que el cliente fue declarado en quiebra, suspensión de pagos o en concurso mercantil.',
						},
					],
					answers: [3],
				},
			]
		},
		{
			id: 4,
			activityId: 4,
			type: 'evaluation',
			maxScore: 100,
			title: 'Módulo 1',
			description: `
			<p>
			
				<br/>
				Antes de comenzar este módulo, deberás responder una evaluación inicial diagnóstica, la cual consta de 13 preguntas que tienen como finalidad valorar los conocimientos que posees.
				<br/>
				<b>¿Estás listo?​​</b>
			</p>`,
			questions: [
				{
					id: 1,
					title: '¿Qué EEFF te permite visualizar un incremento real del Activo?',
					options: [
						{
							id: 1,
							text: 'Estado de Resultados y Balance.',
						},
						{
							id: 2,
							text: 'Balance y Estado de Cambios en el Capital.',
						},
						{
							id: 3,
							text: 'Balance y Flujo de Efectivo.',
						},
						{
							id: 4,
							text: 'Balance, Estados de Cambios en el Capital y Flujo de Efectivo.',
						},
					],
					answers: [3],
				},
				{
					id: 2,
					title: '¿Qué es la porción circulante?',
					options: [
						{
							id: 1,
							text: 'Obligaciones de la deuda LP que debe ser pagado dentro del año contable.',
						},
						{
							id: 2,
							text: 'Obligaciones de deuda CP que debe ser pagado dentro del año contable.',
						},
						{
							id: 3,
							text: 'Obligaciones de deuda LP que debe ser pagado dentro de 2 años.',
						},
						{
							id: 4,
							text: 'Obligaciones de deuda CP que debe ser pagado dentro de 2 años.',
						},
					],
					answers: [1],
				},
				{
					id: 3,
					title: '¿Número de etapas en el proceso de crédito en BBVA?',
					options: [
						{
							id: 1,
							text: '6',
						},
						{
							id: 2,
							text: '7',
						},
						{
							id: 3,
							text: '8',
						},
						{
							id: 4,
							text: '5',
						},
					],
					answers: [2],
				},
				{
					id: 4,
					title: '¿En BBVA cómo clasifica la Administración de las Empresas?',
					options: [
						{
							id: 1,
							text: 'Semiprofesional, Profesional, Institucional y Gobierno Corporativo.',
						},
						{
							id: 2,
							text: 'Familiar, Semiprofesional, Profesional e Institucional.',
						},
						{
							id: 3,
							text: 'Semiprofesional, Profesional e Institucional.',
						},
						{
							id: 4,
							text: 'Familiar, Profesional e Institucional.',
						},
					],
					answers: [2],
				},
				{
					id: 5,
					title: 'Por lo regular, en un crédito Refaccionario ¿Hasta que porcentaje podemos prestar de lo solicitado?',
					options: [
						{
							id: 1,
							text: '100%',
						},
						{
							id: 2,
							text: '90%',
						},
						{
							id: 3,
							text: '50%',
						},
						{
							id: 4,
							text: '75%',
						},
					],
					answers: [2],
				},
				{
					id: 6,
					title: '¿Cuáles son las cinco etapas en el ciclo de vida de la Industria?',
					options: [
						{
							id: 1,
							text: 'Introducción, Crecimiento, Madurez, Renovación y/o Fragmentación.',
						},
						{
							id: 2,
							text: 'Inducción, Crecimiento, Madurez, Renovación y Fragmentación.',
						},
						{
							id: 3,
							text: 'Introducción,Crecimiento, Madurez, Renovación y Cancelación.',
						},
						{
							id: 4,
							text: 'Introducción, Crecimiento, Madurez, Renovación y Estructuración.',
						},
					],
					answers: [1],
				},
				{
					id: 7,
					title: '¿Cuáles son los actores en el Diagrama de Porter?',
					options: [
						{
							id: 1,
							text: 'Compradores, Productos Sustitutos y Proveedores.',
						},
						{
							id: 2,
							text: 'Competidores potenciales, Compradores, Productos Sustitutos y Proveedores.',
						},
						{
							id: 3,
							text: 'Competidores potenciales, Compradores, Productos Sustitutos.',
						},
						{
							id: 4,
							text: 'Competidores potenciales, Compradores y Proveedores.',
						},
					],
					answers: [2],
				},
				{
					id: 8,
					title: '¿Qué te indica la clave del Buró de Crédito número 81?',
					options: [
						{
							id: 1,
							text: 'El Cliente desvió recursos fines distintos pactados en cartera vencida.',
						},
						{
							id: 2,
							text: 'Cliente propició pérdida a Otorgante por falta de pago.',
						},
						{
							id: 3,
							text: 'Cliente declarado en quiebra o en suspensión de pagos.',
						},
						{
							id: 4,
							text: 'Cliente con cartera vencida en trámite judicial.',
						},
					],
					answers: [4],
				},
				{
					id: 9,
					title: '¿Qué es SWAP?',
					options: [
						{
							id: 1,
							text: 'Contrato por el que se acuerda el intercambio de una cantidad concreta.',
						},
						{
							id: 2,
							text: 'Producto financiero cuyo valor se basa en el precio de otro activo.',
						},
						{
							id: 3,
							text: 'Intercambio financiero para convertir un esquema de pagos en otro.',
						},
						{
							id: 4,
							text: 'Instrumento de cobertura para los préstamos con interés variable.',
						},
					],
					answers: [3],
				},
				{
					id: 10,
					title: '¿A qué se refiere cuando una empresa está en estado de insolvencia?',
					options: [
						{
							id: 1,
							text: 'Que no puede pagar el dinero adeudado.',
						},
						{
							id: 2,
							text: 'Que puede pagar el dinero adeudado.',
						},
						{
							id: 3,
							text: 'Que puede pagar parte del dinero adeudado.',
						},
						{
							id: 4,
							text: 'Ninguna respuesta es correcta.',
						},
					],
					answers: [1],
				},
				{
					id: 11,
					title: '¿Para qué sirve hacer un análisis Cash Flow?',
					options: [
						{
							id: 1,
							text: 'Saber si una empresa puede para pagar sus Obligaciones a largo plazo.',
						},
						{
							id: 2,
							text: 'Saber si una empresa puede para pagar sus Obligaciones a corto plazo.',
						},
						{
							id: 3,
							text: 'Saber si una empresa puede para pagar sus Obligaciones a corto y largo plazo.',
						},
						{
							id: 4,
							text: 'Ninguna respuesta es correcta.',
						},
					],
					answers: [2],
				},
				{
					id: 12,
					title: '¿A qué herramienta sustituye ARCE?',
					options: [
						{
							id: 1,
							text: 'Work Flow.',
						},
						{
							id: 2,
							text: 'Fortimax.',
						},
						{
							id: 3,
							text: 'Programa Financiero Digital.',
						},
						{
							id: 4,
							text: 'Saleforce o DWP.',
						},
					],
					answers: [3],
				},
				{
					id: 13,
					title: '¿A qué empresa va dirigida una línea de crédito para Capital de Trabajo permanente?',
					options: [
						{
							id: 1,
							text: 'A ninguna.',
						},
						{
							id: 2,
							text: 'A todas.',
						},
						{
							id: 3,
							text: 'A empresas que realizan compras o ventas estacionales.',
						},
						{
							id: 4,
							text: 'A empresas que registra un crecimiento notable y sostenido.',
						},
					],
					answers: [4],
				},
			]
		},
		{
			id: 5,
			activityId: 8,
			type: 'trivia',
			maxScore: 100,
			title: 'Trivia de aprendizaje',
			description: `
			<p>
				<b>¡Última trivia!</b>
				<br/>
				Esta es tu última oportunidad para ganar puntos con trivia, recuerda que cada pregunta tiene un valor de 10 puntos.
				<br/>
				No olvides utilizar los dos comodines si es necesario.
				<br/>
				<b>¿Listo para poner a prueba tus aprendizajes?</b>
			</p>`,
			questions: [
				{
					id: 1,
					title: '¿En qué consiste una estructuración de crédito con enfoque de negocios?',
					options: [
						{
							id: 1,
							text: 'En el establecimiento de los Términos y Condiciones del crédito, plazos, tasas, garantías, tomando en cuenta todas las mitigantes de riesgo.',
						},
						{
							id: 2,
							text: 'En la estructuración de un crédito, con mejores ventajas económicas para el banco, así como en el establecimiento de los Términos y Condiciones.',
						},
						{
							id: 3,
							text: 'En el establecimiento de los Términos y Condiciones del crédito, que le permitan al Banco fijar un nivel de riesgo/rendimiento aceptable y al mismo tiempo, le proporcionen al cliente la suficiente flexibilidad operativa y financiera para llevar a cabo sus planes de crecimiento, de consolidación y de negocio.',
						},
					],
					answers: [3],
				},
				{
					id: 2,
					title: '¿Cuáles son puntos clave en la estructuración?',
					options: [
						{
							id: 1,
							text: 'Entender y controlar el destino del crédito, identificar las fuentes de pago y evitar prestamos por garantías.',
						},
						{
							id: 2,
							text: 'Conocer y entender profundamente al cliente, así como controlar el destino del crédito, identificar las fuentes de pago, prestar donde están los activos y flujos, y evitar prestar por garantías o nombres; conocer los demás créditos, en el caso de grupos prever transferencias entre empresas o entidades relacionadas.',
						},
						{
							id: 3,
							text: 'Identificar las fuentes de pago, establecer garantías o nombres, conocer los demás créditos.',
						},
					],
					answers: [2],
				},
				{
					id: 3,
					title: '¿Cuáles son los elementos de la etapa de formalización? ',
					options: [
						{
							id: 1,
							text: 'Destino, plazo, monto, moneda, formas de disposición, tasa de interés y covenant.',
						},
						{
							id: 2,
							text: 'Promoción, análisis, y detección de riesgo.',
						},
						{
							id: 3,
							text: 'FPP, FAP, autorización.',
						},
					],
					answers: [1],
				},
				{
					id: 4,
					title: '¿Cuál es la clasificación de los productos de crédito, de acuerdo con su destino?',
					options: [
						{
							id: 1,
							text: 'Corto plazo y largo plazo, riesgo de tesorería y riesgo de firma.',
						},
						{
							id: 2,
							text: 'Riesgo de firma, riesgo financiero de corto plazo, riesgo comercial, riesgo financiero de largo plazo sin garantía, riesgo financiero de largo plazo con garantía, riesgo de tesorería.',
						},
						{
							id: 3,
							text: 'Cartas de crédito y stand by, riesgo de firma, riesgo financiero de corto plazo, riesgo comercial, riesgo financiero de largo plazo sin garantía.',
						},
					],
					answers: [2],
				},
				{
					id: 5,
					title: '¿Cuál es el esquema de riesgo Comercial?',
					options: [
						{
							id: 1,
							text: 'Financiamiento donde el proveedor de bienes o servicios obtiene liquidez inmediata al ceder sus derechos de crédito.',
						},
						{
							id: 2,
							text: 'Crédito dirigido a la compra de materias primas y financiamiento para bienes y servicios.',
						},
						{
							id: 3,
							text: 'Crédito dirigido a vendedores de insumos dirigido a la compra de materias primas con liquidez inmediata.',
						},
					],
					answers: [1],
				},
				{
					id: 6,
					title: '¿Qué es un derivado?',
					options: [
						{
							id: 1,
							text: 'Son elementos financieros cuyo valor depende de un activo intercambiado en los mercados de valores, por ejemplo, acciones o bonos, los cuales pueden ser de corto o largo plazo.',
						},
						{
							id: 2,
							text: 'Son instrumentos financieros cuyo valor deriva de la evolución de los precios de otro activo, denominado “activo subyacente” que puede ser: una acción, una cesta de acciones, un valor de renta fija, una divisa, materias primas, tipos de interés.',
						},
						{
							id: 3,
							text: 'Un derivado del petróleo según la composición del crudo y la demanda, las refinerías pueden producir distintos productos derivados del petróleo.',
						},
					],
					answers: [2],
				},
				{
					id: 7,
					title: '¿Cuáles son las formas de presentación en la propuesta de riesgo?',
					options: [
						{
							id: 1,
							text: 'Autorización, renovación, condicionado, revisión anual y ratificación.',
						},
						{
							id: 2,
							text: 'Establecimiento, informativo, modificación, renovación, cancelación, revisión anual y ratificación.',
						},
						{
							id: 3,
							text: 'Establecimiento, modificación, renovación, ratificación y cancelación.',
						},
					],
					answers: [2],
				},
				{
					id: 8,
					title: '¿Cuál es el negocio del banco?',
					options: [
						{
							id: 1,
							text: 'Prestar dinero y generar intereses.',
						},
						{
							id: 2,
							text: 'Captar ahorro y prestarlo.',
						},
						{
							id: 3,
							text: 'Ganar intereses y no perder capitales.',
						},
					],
					answers: [3],
				},
				{
					id: 9,
					title: '¿Cuáles son los tipos de garantía?',
					options: [
						{
							id: 1,
							text: 'Personales y reales.',
						},
						{
							id: 2,
							text: 'Inmuebles y mercancías.',
						},
						{
							id: 3,
							text: 'Terrenos y maquinaria.',
						},
					],
					answers: [1],
				},
				{
					id: 10,
					title: '¿Cuáles son las Garantías de Fomento?',
					options: [
						{
							id: 1,
							text: 'Las que respalda el gobierno.',
						},
						{
							id: 2,
							text: 'Fideicomisos.',
						},
						{
							id: 3,
							text: 'FIRA, NAFIN y BANCOMEXT.',
						},
					],
					answers: [3],
				},
				{
					id: 11,
					title: '¿Cuáles son los productos (créditos Banca Empresarial) de BBVA que requieren contrato para su formalización?',
					options: [
						{
							id: 1,
							text: 'Simple y aval simple con hipoteca naval, simple con garantía sobre aeronaves, refaccionario y/o habilitación o avió, con garantía sobre ganado y/o garantías propias, refaccionario y/o habilitación o avió; con garantía sobre derechos de concesión para uso de un pozo y simple con garantía prendaria. Cuenta corriente a LP. con garantía hipotecaria, cuenta corriente con garantía prendaria, cuenta corriente. plan piso, refaccionario y/o habilitación o avió, con garantía hipotecaria industrial y/o garantías propias, simple y aval y Simple con hipoteca naval. ',
						},
						{
							id: 2,
							text: 'Cuenta corriente y/o simple, con garantía hipotecaria, cuenta corriente con garantía prendaria, cuenta corriente. plan piso, Refaccionario y/o habilitación o avió, con garantía hipotecaria industrial y/o garantías propias, simple y aval simple con hipoteca naval, simple con garantía sobre aeronaves, refaccionario y/o habilitación o avió, con garantía sobre ganado y/o garantías propias, refaccionario y/o habilitación o avió. con garantía sobre derechos de concesión para uso de un pozo y simple con garantía prendaria. ',
						},
						{
							id: 3,
							text: 'Cuenta corriente a LP. con garantía hipotecaria, cuenta corriente con garantía prendaria, cuenta corriente. plan piso, refaccionario y/o habilitación o avió, con garantía hipotecaria industrial y/o garantías propias, simple y aval y simple con hipoteca naval.',
						},
					],
					answers: [2],
				},
			]
		},
		{
			id: 6,
			activityId: 10,
			type: 'evaluation',
			maxScore: 100,
			title: 'Módulo 2',
			description: `
			<p>
			
				<br/>
				Antes de comenzar este módulo, deberás responder una evaluación inicial, la cual consta de 10 preguntas que tienen como finalidad valorar tus conocimientos previos a la última etapa de tu Certifiación en Crédito.
				<br/>
				<b>¿Estás listo?​​</b>
			</p>`,
			questions: [
				{
					id: 1,
					title: '¿Qué herramienta utilizamos para analizar la capacidad de pago proyectada de una empresa o proyecto?',
					options: [
						{
							id: 1,
							text: 'Tasa Interna de Retorno.',
						},
						{
							id: 2,
							text: 'Proyecciones Financieras.',
						},
						{
							id: 3,
							text: 'Modelo Estructural.',
						},
						{
							id: 4,
							text: 'Risk Analist.',
						},
					],
					answers: [2],
				},
				{
					id: 2,
					title: '¿Qué modelo de proyecciones utilizamos?',
					options: [
						{
							id: 1,
							text: 'Balance de arranque y negocio en marcha.',
						},
						{
							id: 2,
							text: 'Negocio en marcha.',
						},
						{
							id: 3,
							text: 'Valor económico agregado.',
						},
						{
							id: 4,
							text: 'Ninguna de las anteriores.',
						},
					],
					answers: [1],
				},
				{
					id: 3,
					title: '¿Qué tipo de escenarios debemos utilizar en las Proyecciones Financieras?',
					options: [
						{
							id: 1,
							text: 'Optimista.',
						},
						{
							id: 2,
							text: 'Medio.',
						},
						{
							id: 3,
							text: 'Escenario de cumplimiento ajustado.',
						},
						{
							id: 4,
							text: 'Optimista, medio y escenario de cumplimiento ajustado.',
						},
					],
					answers: [4],
				},
				{
					id: 4,
					title: '¿Qué elementos debemos considerar para realizar unas Proyecciones Financieras?',
					options: [
						{
							id: 1,
							text: 'EEFF, Premisas de valuación, Cuadro de pasivos y carta.',
						},
						{
							id: 2,
							text: 'EEFF, Premisas de valuación, Cuadro de pasivos y destino.',
						},
						{
							id: 3,
							text: 'EEFF, Premisas de valuación, Cuadro de pasivos y monto.',
						},
						{
							id: 4,
							text: 'EEFF, Premisas de valuación, Cuadro de pasivos y plazo.',
						},
					],
					answers: [1],
				},
				{
					id: 5,
					title: '¿Cuáles son las formas de defender una solicitud de financiamiento a largo plazo?',
					options: [
						{
							id: 1,
							text: 'Adicionar una garantía hipotecaria, reducir monto o O.S.',
						},
						{
							id: 2,
							text: 'Periodo de gracia, mayor plazo de pago, pagos crecientes y/o Balloon payment.',
						},
						{
							id: 3,
							text: 'Con una garantía hipotecaria o liquidar y reducir monto.',
						},
						{
							id: 4,
							text: 'No hay forma de defender la operación ante riesgos.',
						},
					],
					answers: [2],
				},
				{
					id: 6,
					title: '¿En cuántos tipos de Administración clasifica BBVA a las Empresas?',
					options: [
						{
							id: 1,
							text: '4',
						},
						{
							id: 2,
							text: '5',
						},
						{
							id: 3,
							text: '3',
						},
						{
							id: 4,
							text: '7',
						},
					],
					answers: [1],
				},
				{
					id: 7,
					title: '¿Cuáles son los tipos de Administración conforme a la clasificación que BBVA otorga a las Empresas?',
					options: [
						{
							id: 1,
							text: 'Familiar y profesional.',
						},
						{
							id: 2,
							text: 'Familiar, semiprofesional y profesional.',
						},
						{
							id: 3,
							text: 'Familiar, semiprofesional, profesional e institucional.',
						},
						{
							id: 4,
							text: 'Familiar, profesional e Institucional.',
						},
					],
					answers: [3],
				},
				{
					id: 8,
					title: '¿Para qué nos sirve ARCE?',
					options: [
						{
							id: 1,
							text: 'Nuevo formato institucional para presentar una solicitud de financiamiento.',
						},
						{
							id: 2,
							text: 'Nueva herramienta para hacer un Análisis Horizontal.',
						},
						{
							id: 3,
							text: 'Nueva herramienta para realizar un Programa Financiero.',
						},
						{
							id: 4,
							text: 'Nueva herramienta para digitalizar el check list de crédito.',
						},
					],
					answers: [4],
				},
				{
					id: 9,
					title: '¿Qué indica el Payback en un Análisis Financiero?',
					options: [
						{
							id: 1,
							text: 'Meses en que un deudor puede pagar sus deudas financieras.',
						},
						{
							id: 2,
							text: 'Años en que un deudor puede pagar sus deudas financieras.',
						},
						{
							id: 3,
							text: 'Días en que un deudor puede pagar sus deudas financieras.',
						},
						{
							id: 4,
							text: 'Días en que rota sus inventarios una empresa.',
						},
					],
					answers: [2],
				},
				{
					id: 10,
					title: '¿Cómo se determina la Deuda Financiera neta?',
					options: [
						{
							id: 1,
							text: 'Deuda Financiera menos Proveedores.',
						},
						{
							id: 2,
							text: 'Pasivo total menos Pasivo a Corto Plazo.',
						},
						{
							id: 3,
							text: 'Deuda Financiera menos Deuda a Corto Plazo.',
						},
						{
							id: 4,
							text: 'Deuda Financiera total menos Caja y Bancos.',
						},
					],
					answers: [4],
				},
			],
		}	
	],
}